import useName from "../hooks/useName";

export default function Name() {
  const {
    name,
    handleChange,
    handleSubmit,
    Button,
    Input,
    loading,
    submitting,
    authToken,
  } = useName();

  if (
    loading ||
    !Button ||
    !Input
  ) {
    return (
      <div className="flex items-center justify-center w-full h-screen">
        <div className="w-10 h-10 border-4 border-gray-300 rounded-full border-t-red-600 animate-spin" />
      </div>
    );
  }

  return (
    <div className="w-full max-w-[280px] md:max-w-[511px] mx-auto min-h-[30vh] flex flex-col justify-between">

      <Input
        token={authToken}
        value={name}
        onChange={handleChange}
        placeholder="First name"
        className="w-full h-[45px] md:h-[51px] rounded-xl border px-4 text-[12px] md:text-[16px]"
      />

      <Button
        token={authToken}
        onClick={handleSubmit}
        disabled={
          !name ||
          submitting
        }
        className={`w-full h-[45px] md:h-[51px] rounded-xl font-bold font-montserrat ${
          name &&
          !submitting
            ? "bg-[#CF0018] text-white"
            : "bg-gray-300 text-[#827C7C]"
        }`}
      >
        {submitting
          ? "Saving..."
          : "Continue"}
      </Button>

    </div>
  );
}